import type { NavItem } from "./config.nav";
import type { NavTabItem } from "./types";

interface ToNavTabItemsOptions {
  pathname?: string;
  onNavigate?: (url: string) => void;
}

export const toNavTabItems = (
  items: NavItem[],
  { pathname, onNavigate }: ToNavTabItemsOptions = {},
): NavTabItem[] =>
  items.map((item) => {
    const routed = !item.external && !!onNavigate;

    return {
      title: item.title,
      href: routed ? undefined : item.url,
      external: item.external,
      badge: item.badge,
      active: !item.external && item.url === pathname,
      onClick: routed ? () => onNavigate(item.url) : undefined,
    };
  });
